import { render } from "./EnableStaticNat.vue?vue&type=template&id=5e5c4a3c&scoped=true"
import script from "./EnableStaticNat.vue?vue&type=script&lang=js"
export * from "./EnableStaticNat.vue?vue&type=script&lang=js"

import "./EnableStaticNat.vue?vue&type=style&index=0&id=5e5c4a3c&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5c4a3c"]])

export default __exports__